import { render, staticRenderFns } from "./pictureFrame.vue?vue&type=template&id=3205b64f&scoped=true&"
import script from "./pictureFrame.vue?vue&type=script&lang=js&"
export * from "./pictureFrame.vue?vue&type=script&lang=js&"
import style0 from "./pictureFrame.vue?vue&type=style&index=0&id=3205b64f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3205b64f",
  null
  
)

component.options.__file = "pictureFrame.vue"
export default component.exports